module.exports = __webpack_public_path__ + "img/melia-room-3.ee0d5d50.jpg";